module.exports = __webpack_public_path__ + "img/2012-12-14 20.01.17.a54e52a1.jpg";